module.exports = __webpack_public_path__ + "61c2d140.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/crown.svg
// module id = 2253
// module chunks = 19 20 32